import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const fadeOut = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

const CreditAnimation = ({ show, type }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: -20,
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#4890fe',
        fontWeight: 600,
        fontSize: '0.875rem',
        animation: `${fadeOut} 1s ease-out forwards`,
        pointerEvents: 'none',
        zIndex: 1
      }}
    >
      -1
    </Box>
  );
};

export default CreditAnimation; 